//import {PopupMessage} from '../popup/popup';
import PreLoader from '../../modules/preloader';
import functions from '../../modules/functions';
import Trackers from '../tracker/tracker';
import {RetailRocket} from "../../modules/tracker/retailrocket";
import md5 from '../../modules/md5';

require('../impromptu/impromptu');

let autoComplete = require('./../autocomplete/autocomplete');
let styleSelects = require('./../../blocks/styled-select/styled-select.js');

/**
 *  Класс для работы авторизации/регистрации по смс
 */
export class LoginBySms {
    constructor() {
        this.loader = new PreLoader();
        this.isInit = false;
        this.timeReset = 60;
        this.timerId = null;
        this.retailRocket = new RetailRocket();

        /**
         * Вот эта переменная нужна чтобы не отправлять запрос
         * на проверку кода и авторизацию после ввода 4 символов
         * @type {boolean}
         */
        this.isSendLoginBySmsQuery = false;
    }

    /**
     *  Подтягивает контент для формы и показывает окно авторизации
     */
    static showPopup(isOneClick = false, productId = null) {
        $.ajax({
            url: '/ajax/component/maximaster:widget.login.by.sms.popup/',
            type: 'GET',
            data: {
                isOneClick: isOneClick ? 'Y' : 'N',
                productId: productId
            },
            success: function(result) {
                $.prompt(result.html);
                //PopupMessage.show(result.html);
            }
        });
    }

    /**
     * Инициализация элементов DOM
     * @param jqActionLink
     */
    initElements(jqActionLink) {
        if (this.isInit) {
            return;
        }

        let _self = this;
        this.isInit = true;
        this.jqActionLink = jqActionLink;
        this.loginMainContainer = jqActionLink.parents('.js-login-by-sms-main-container');
        this.recoveryMainContainer = this.loginMainContainer.next();

        this.jqMode = this.loginMainContainer.find('.js-mode');
        this.jqTestSmsCode = this.loginMainContainer.find('.js-test-code');

        this.jqInputPhoneNumber = this.loginMainContainer.find('.js-phone');

        this.jqInputNameContainer = this.loginMainContainer.find('.js-name-container');
        this.jqInputName = this.jqInputNameContainer.find('input');

        this.jqInputLastNameContainer = this.loginMainContainer.find('.js-last-name-container');
        this.jqInputLastName = this.jqInputLastNameContainer.find('input');

        this.jqInputEmailContainer = this.loginMainContainer.find('.js-email-container');
        this.jqInputEmail = this.jqInputEmailContainer.find('input');

        this.jqInputLocationContainer = this.loginMainContainer.find('.js-last-location-container');
        this.jqInputLocation = this.jqInputLocationContainer.find('input');

        this.jqSelectUserTypeContainer = this.loginMainContainer.find('.js-last-user-type-container');
        this.jqSelectUserType = this.jqSelectUserTypeContainer.find('select');

        this.jqCodeContainer = this.loginMainContainer.find('.js-code-container');
        this.jqCodeContainerTimerText = this.loginMainContainer.find('.js-code-timer-text-container');

        this.jqTimer = this.loginMainContainer.find('.js-timer');

        this.jqInputSmsCode = this.jqCodeContainer.find('input');

        this.jqErrorContainer = this.loginMainContainer.find('.js-error-container');

        this.token = md5([...this.loginMainContainer.find('.js-token').val()].reverse().join(''));

        /**
         * Если это форма заказ в 1 клик
         * @type {boolean}
         */
        this.isOneClick = this.loginMainContainer.find('.js-onle-click').val() === 'Y';
        this.productId = this.loginMainContainer.find('.js-onle-click-product').val();

        /**
         *  Вот это событие для вставки кода смс на мобиле
         */
        this.jqInputSmsCode.on('input', function(e) {
            let code = $(this).val();
            if (code.length === 4) {
                if (_self.isSendLoginBySmsQuery === true) {
                    return;
                }

                let phoneNumber = $.trim(_self.jqInputPhoneNumber.val());
                _self.login(phoneNumber, code);
                event.preventDefault();
            }
        });

        this.jqInputSmsCode.on('keydown', function(event) {
            _self.hideErrorInput($(this));

            // Разрешаем: backspace, delete, tab и escape
            if (
                event.keyCode === 46 ||
                event.keyCode === 8 ||
                event.keyCode === 9 ||
                event.keyCode === 27 ||
                // Разрешаем: Ctrl+A
                (event.keyCode === 65 && event.ctrlKey === true) ||
                /*(event.keyCode === 86 && event.ctrlKey === true) ||*/
                // Разрешаем: home, end, влево, вправо
                (event.keyCode >= 35 && event.keyCode <= 39)
            ) {
                // Ничего не делаем
                return;
            } else {
                let code = $(this).val();
                if (code.length === 4) {
                    event.preventDefault();
                    return;
                }

                // Запрещаем все, кроме цифр на основной клавиатуре, а так же Num-клавиатуре
                if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                    event.preventDefault();
                }
            }
        });

        this.jqInputSmsCode.on('keyup', function() {
            if (
                event.keyCode === 46 ||
                event.keyCode === 8 ||
                event.keyCode === 9 ||
                event.keyCode === 27 ||
                // Разрешаем: Ctrl+A
                (event.keyCode === 65 && event.ctrlKey === true) ||
                (event.keyCode === 86 && event.ctrlKey === true) ||
                // Разрешаем: home, end, влево, вправо
                (event.keyCode >= 35 && event.keyCode <= 39)
            ) {
                // Ничего не делаем
                return;
            }

            let code = $(this).val();

            if (code.length === 4) {
                if (_self.isSendLoginBySmsQuery === true) {
                    return;
                }

                let phoneNumber = $.trim(_self.jqInputPhoneNumber.val());
                _self.login(phoneNumber, code);
            }
        });
    }

    /**
     * Запрос смс кода
     * @param jqActionLink
     */
    getSmsCode(jqActionLink) {
        this.initElements(jqActionLink);

        let _self = this;

        let phoneNumber = $.trim(this.jqInputPhoneNumber.val());
        if (phoneNumber.length === 0) {
            return;
        }

        let mode = this.jqMode.val();

        let ajaxPath, dataParams;
        if (mode === 'AUT') {
            // https://www.smartbuy.ru/ajax/action/basket_add_popup/get_data_layer/
            //ajaxPath = '/ajax/action/maximaster:widget.login.by.sms/get_sms_code/';
            ajaxPath = '/ajax/action/widget_login_by_sms/get_sms_code/';
            dataParams = {
                phone: phoneNumber,
                isOneClick: _self.isOneClick ? 'Y' : 'N',
                _t: _self.token
            };
        }

        if (mode === 'REGISTER') {
            //ajaxPath = '/ajax/action/maximaster:widget.login.by.sms/registration/';
            ajaxPath = '/ajax/action/widget_login_by_sms/registration/';
            dataParams = {
                phone: phoneNumber,
                name: $.trim(this.jqInputName.val()),
                last_name: $.trim(this.jqInputLastName.val()),
                email: $.trim(this.jqInputEmail.val()),
                location: $.trim(this.jqInputLocation.val()),
                userType: $.trim(this.jqSelectUserType.val()),
                isOneClick: _self.isOneClick ? 'Y' : 'N',
                _t: _self.token
            };
        }

        this.loader.show();

        $.ajax({
            url: ajaxPath,
            type: 'POST',
            data: dataParams,
            success: function(result) {
                _self.loader.hide();

                _self.jqErrorContainer.empty();
                _self.hideErrorInput(_self.jqInputName);
                _self.hideErrorInput(_self.jqInputLastName);
                _self.hideErrorInput(_self.jqInputEmail);
                _self.hideErrorInput(_self.jqInputLocation);

                let data = result.data;

                if (result.code === 401) {
                    /**
                     *  Если при попытке регистрации возникли ошиьки
                     *  показываем их
                     */
                    if (data.mode === 'RIGISTR_ERROR_FIELDS') {
                        let errors = data.errors;
                        let count = errors.length;
                        if (count > 0) {
                            for (let i = 0; i < count; i++) {
                                if (errors[i].TYPE === 'INPUT_NAME_ERROR') {
                                    _self.showErrorInput(_self.jqInputName);
                                }

                                if (errors[i].TYPE === 'INPUT_LAST_NAME_ERROR') {
                                    _self.showErrorInput(_self.jqInputLastName);
                                }

                                if (errors[i].TYPE === 'INPUT_EMAIL') {
                                    _self.showErrorInput(_self.jqInputEmail);
                                }

                                if (errors[i].TYPE === 'INPUT_LOCATION') {
                                    _self.showErrorInput(_self.jqInputLocation);
                                }

                                if (errors[i].TYPE === 'ERROR_EMAIL_ACCOUNT') {
                                    _self.jqErrorContainer.html(errors[i].TEXT);
                                }
                            }
                        }

                        return;
                    }

                    _self.jqErrorContainer.html(data.error);

                    return;
                }

                let mode = result.data.mode;
                switch (mode) {
                    /**
                     *  Пользователь существует, ждем ввод кода СМС
                     */
                    case 'SET_SMS_CODE':
                        _self.jqCodeContainer.show();
                        _self.jqInputSmsCode.focus();
                        _self.jqCodeContainerTimerText.show();
                        _self.jqInputPhoneNumber.prop('disabled', true);
                        _self.jqActionLink.addClass('button--disable-login').attr('data-disabled', 'Y');
                        _self.timerSecond(_self.timeReset, 'aut');

                        /**
                         *  @todo убрать на проде
                         */
                        //_self.jqTestSmsCode.val(result.data.code);

                        break;

                    /**
                     *  Если в ответе пришла метка на регистрацию
                     *  показываем дополнительные поля и устанавливем типа
                     *  следущего запроса  REGISTER
                     */
                    case 'SHOW_REGISTER_FIELDS':
                        _self.jqInputPhoneNumber.prop('disabled', true);
                        _self.jqInputNameContainer.show();
                        _self.jqInputLastNameContainer.show();
                        _self.jqInputEmailContainer.show();
                        _self.jqInputLocationContainer.show();
                        _self.jqSelectUserTypeContainer.show();
                        _self.jqMode.val('REGISTER');
                        styleSelects.styleSelects($('.js-styled-select'));
                        //window.beautyShopTracker.registerPageViewed();

                        break;

                    case 'REGISTER_RESULT':
                        _self.jqCodeContainer.show();
                        _self.jqCodeContainerTimerText.show();
                        _self.jqInputName.prop('disabled', true);
                        _self.jqInputLastName.prop('disabled', true);
                        _self.jqInputEmail.prop('disabled', true);
                        _self.jqInputPhoneNumber.prop('disabled', true);
                        _self.jqInputLocation.prop('disabled', true);
                        _self.jqSelectUserType.prop('disabled', true);

                        _self.jqActionLink.addClass('button--disable-login').attr('data-disabled', 'Y');

                        _self.timerSecond(_self.timeReset, 'reg');

                        _self.retailRocket.setProfile({
                            email: dataParams.email,
                            phone: dataParams.phone,
                            isAgreedToReceiveMarketingMail: true
                        });

                        /**
                         *  @todo убрать на проде
                         */
                        //_self.jqTestSmsCode.val(result.data.code);

                        break;
                }
            }
        });
    }

    /**
     * Заказ в один клик
     * @param data
     */
    orderOneClick(data) {
        $.ajax({
            //url: '/ajax/action/maximaster:widget.order/ajaxOneClickLoginBySms/',
            //url: '/ajax/action/widget_order/ajaxOneClickLoginBySms/',
            url: '/ajax/action/order_oneclick/buy/',
            type: 'POST',
            data: data,
            success: function(result) {
                if (result.data['SUCCESS']) {
                    //window.beautyShopTracker.orderPageOneClickOrderButtonClicked();
                    //window.beautyShopTracker.subscriptionPopupForms(data.EMAIL);
                    window.location.href = result.data['ORDER_PAGE'];
                } else {
                    alert(result.data['ERROR']);
                }
            }
        });
    }

    /**
     * Авторизация после получения кода
     * @param phoneNumber
     * @param code
     */
    login(phoneNumber, code) {
        let _self = this;

        _self.loader.show();
        //clearTimeout(this.timerId);

        _self.isSendLoginBySmsQuery = true;

        $.ajax({
            //url: '/ajax/action/maximaster:widget.login.by.sms/login/',
            url: '/ajax/action/widget_login_by_sms/login/',
            type: 'POST',
            data: {
                code: code,
                phoneNumber: phoneNumber
            },
            success: function(result) {
                _self.isSendLoginBySmsQuery = false;
                let action = result.data.ACTION || '';

                const trackers = new Trackers();

                if (result.code === 200) {
                    if (_self.isOneClick) {
                        let oneClickData = result.data;
                        const productsParams = [];
                        productsParams.push({ id: parseInt(_self.productId), quantity: 1 });

                        oneClickData.products = productsParams;

                        _self.orderOneClick(oneClickData);
                        return;
                    }

                    if (action === 'AUT') {
                    }

                    if (action === 'REG') {
                        trackers.getTracker('gtm').pushEvent('completeRegistration');
                    }

                    functions.setCookie('BITRIX_SM_is_aut', 'Y', { expires: 604800, path: '/' });

                    trackers.userAuthorized(result.data);

                    location.reload();
                }

                if (result.code === 400) {
                    _self.showErrorInput(_self.jqInputSmsCode);
                    _self.loader.hide();
                    return;
                }

                if (result.code === 500) {
                    alert('Ошибка, попробуйте позже, мы уже занимаемся устранением проблемы.');
                    _self.loader.hide();
                }
            }
        });
    }

    showErrorInput(jqInput) {
        jqInput
            .parent()
            .prev()
            .show();
        jqInput.addClass('form__input--error');
    }

    hideErrorInput(jqInput) {
        jqInput
            .parent()
            .prev()
            .hide();
        jqInput.removeClass('form__input--error');
    }

    /**
     * Таймер для вывода счетчика
     * @param count - кол-во сек
     * @param mode - для авторизации и для регистрации
     */
    timerSecond(count, mode) {
        if (count > 0) {
            let _self = this;
            this.jqTimer.text(count + this.declOfNum(count, [' секунда', ' секунды', ' секунд']));
            this.timerId = setTimeout(function() {
                _self.timerSecond(count - 1, mode);
            }, 1000);
        } else {
            if (mode === 'aut') {
                this.resetAutFields();
            }

            if (mode === 'reg') {
                this.resetRegFields();
            }
        }
    }

    declOfNum(number, titles) {
        let cases = [2, 0, 1, 1, 1, 2];
        return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
    }

    resetAutFields() {
        this.jqCodeContainerTimerText.hide();
        this.jqActionLink.removeClass('button--disable-login').attr('data-disabled', 'N');
        this.jqInputPhoneNumber.prop('disabled', false);
    }

    resetRegFields() {
        this.jqCodeContainerTimerText.hide();
        this.jqActionLink.removeClass('button--disable-login').attr('data-disabled', 'N');
    }

    getHtmlRecoveryByEmail() {
        let _self = this;

        $.ajax({
            url: '/ajax/action/widget_login_by_sms/get_html_recovery_by_email/',
            type: 'GET',
            data: {
                email: this.jqInputEmail.val()
            },
            success: function(result) {
                _self.loginMainContainer.hide();
                _self.recoveryMainContainer.show().html(result.html);
            }
        });
    }

    showFormLoginBySms() {
        this.loginMainContainer.show();
        this.recoveryMainContainer.hide().empty();
    }

    sendRecoveryEmail() {
        let email = this.recoveryMainContainer.find('.js-email ').val();

        let _self = this;

        this.loader.show();

        $.ajax({
            url: '/ajax/action/widget_login_by_sms/send_email_for_recovery/',
            type: 'GET',
            data: {
                email: email
            },
            data: {
                email: this.jqInputEmail.val()
            },
            success: function(result) {
                _self.loader.hide();

                if (result.code === 401) {
                    alert('Ошибка, попробуйте позже');
                    return;
                }

                if (result.code === 200) {
                    _self.recoveryMainContainer.find('.js-recovery-form-fields-container').hide();
                    _self.recoveryMainContainer.find('.js-recovery-result-container').show();
                }
                //_self.loginMainContainer.hide();
                //_self.recoveryMainContainer.show().html(result.html);
            }
        });
    }
}

jQuery(function() {
    window.LoginBySms = new LoginBySms();

    /**
     *  Открытие окна с формой авторизации
     */
    $(document).on('click', '.js-login-by-sms-show-popup', function() {
        LoginBySms.showPopup();
        window.LoginBySms = new LoginBySms();
    });

    /**
     *  Отправка запроса на отправку смс
     */
    $(document).on('click', '.js-login-by-sms-action-link', function() {
        let isDisabled = $(this).attr('data-disabled') === 'Y';
        if (isDisabled) {
            return;
        }

        window.LoginBySms.getSmsCode($(this));
    });

    /**
     *  Показ формы для запроса восстановления пароля
     */
    $(document).on('click', '.js-recovery-by-email-link', function() {
        window.LoginBySms.getHtmlRecoveryByEmail();
        return false;
    });

    /**
     *  Переход к форме авторизации
     */
    $(document).on('click', '.js-show-login-by-sms-form', function() {
        window.LoginBySms.showFormLoginBySms();
        return false;
    });

    /**
     *  Отправка сообщения на воссатновление аккаунта
     */
    $(document).on('click', '.js-send-recovery-email-link', function() {
        window.LoginBySms.sendRecoveryEmail();
        return false;
    });

    $(document).on('click', '.js-one-click-aut', function() {
        let productId = $(this).attr('data-product-id');
        LoginBySms.showPopup(true, productId);
        window.LoginBySms = new LoginBySms();
        return false;
    });

    /**
     * Это нужно чтобы после авторизации и загрузки страницы выполнить метод
     * userAuthorizedMain
     */
    let isAfterAut = functions.getCookie('BITRIX_SM_is_aut') === 'Y';
    if (isAfterAut) {
        //window.beautyShopTracker.userAuthorizedMain({});
        functions.deleteCookie('BITRIX_SM_is_aut');
    }

    $(document).on('focus', '.js-autocomplete', function() {
        autoComplete.setAutocomplete($('.js-autocomplete'));
    });
});



// WEBPACK FOOTER //
// ./blocks/login-by-sms/login-by-sms.js